export const getCognitoUserQueryKey = () => ['cognito-user'];
export const getUserQueryKey = () => ['user'];
